const { store$ } = require("@redux/store");
const { map, distinctUntilChanged, filter } = require("rxjs");

/**
 * TODO: Rebrand Code Improvement
 * This code helps to prevent affect not B1 version.
 * Remove the links on the backend.
 */
const componentLinksToInclude = ['sign-in', 'account', 'sign-out']

const subMenuAccountList = document.querySelector('[data-sub-menu-account-list]');
const subMenuAccountContainer = document.querySelector('[data-sub-menu-account-container]');
const linkSelector = (state) => state?.userProfile?.links;
const invalidValuesFilter = (value) => !!value && value.length > 0;
const drawMenu = (links) => {
  const linksToPaint = links.filter((link) => componentLinksToInclude.includes(link.component));
    linksToPaint.forEach(link => {
        const li = document.createElement('li');
        li.dataset.component = link?.component;
        const anchor = document.createElement('a');
        anchor.href = link?.url;
        anchor.innerText = link.text;
        anchor.classList.add('nhs-c-standard-link--medium-regular', 'nhs-mq-nav__subnav-account-link--large');
        if (link.ShouldOpenNewTab) {
          anchor.target = '_blank';
          anchor.rel = 'noopener noreferrer';
        }
        anchor.dataset.qa = link?.component;
        li.appendChild(anchor);
        subMenuAccountList.appendChild(li);
        if (link?.component === 'account') {
            const signInToggle = document.querySelector('[data-sign-in-toggle]');
            
            signInToggle.classList.remove('nhs-mq-icon__unauthed-user--24-large');
            signInToggle.classList.add('nhs-mq-icon__authed-user--24-large');
        }
    });
    subMenuAccountContainer.removeAttribute('hidden')
 };

store$.pipe(
  map(linkSelector),
  distinctUntilChanged(),
  filter(invalidValuesFilter)
).subscribe(drawMenu);